import { useEffect, useState } from 'react'
import { environment } from '../../environments/environment'
import DOMPurify from 'dompurify'

interface HomeText {
    title: string
    subtitle: string
}

export function useHomeText() {
    const [loading, setLoading] = useState(true)
    const [text, setText] = useState<HomeText | undefined>(undefined)
    const [textHtml, setTextHtml] = useState<HomeText>({
        title: '',
        subtitle: '',
    })

    useEffect(() => {
        getHomeText()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function textToHtml(text: string) {
        const htmlDirty = text
            ? text.replaceAll('\n', ' <br />').toUpperCase()
            : ''
        const htmlClean = DOMPurify.sanitize(htmlDirty)
        return htmlClean
    }

    async function getHomeText() {
        fetch(`${environment.assetBaseUrl}/public-assets/home-text-data.json`, {
            method: 'GET',
        })
            .then(async (resp) => {
                setLoading(false)
                if (resp.status !== 200) {
                    console.error('Error retrieving home text data', resp)
                } else {
                    const fetchedResp: any = await resp.json()
                    const groomedData: HomeText = {
                        title: fetchedResp.title,
                        subtitle: fetchedResp.subtitle,
                    }
                    setText(groomedData)
                    setTextHtml({
                        title: textToHtml(groomedData.title),
                        subtitle: textToHtml(groomedData.subtitle),
                    })
                }
            })
            .catch((error) => {
                setLoading(false)
                console.error('Error retrieving home text data', error)
            })
    }

    return { loading, text, textHtml }
}
